import { Injectable, isDevMode, inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/Auth/auth.service';
import { SwUpdate } from '@angular/service-worker';
import { ToastService } from 'src/app/services/toast.service';
import { navigateToLogin } from '../services/LogoutInterceptor/logoutinterceptor';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private router = inject(Router);
  private authservice = inject(AuthService);
  private swupdate = inject(SwUpdate);
  private toastr = inject(ToastService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // // Check service worker updates less frequently to avoid refresh loops
    // if (!isDevMode() && Math.random() > 0.95) {
    //   this.swupdate.checkForUpdate();
    // }

    if (this.authservice.isLoggedIn()) {
      return true;
    }

    let refresh = this.authservice.getRefreshToken();
    if (Math.floor(Date.now() / 1000) > refresh.expiresAt && localStorage.getItem('repID') == null) {
      navigateToLogin(this.toastr, this.router, route);
      return false;
    }

    return true;
  }
}
